import React from 'react';
import Dot from '../Dot';

interface RulesDialogInterface {
    closeDialog: any;
};

function RulesDialog({closeDialog}: RulesDialogInterface) {
    const closeIcon = require("../images/close.png");
    const judgeHammer = require("../images/judgeHammerBlack.png");

    const handleClose = () => {
        closeDialog()
    }

    return (
        <div className="rulesDialogWrapper">
            <div className="dialogTop">
                <div className="dialogCloseWrapper" tabIndex={0} onClick={handleClose} onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        handleClose();
                    }
                }}>
                    <img className="dialogCloseIcon" src={closeIcon} alt="close"/>
                </div>
            </div>
            <div className="rulesDialogMiddle">
                <div className="rulesDialogRulesTitle">RULES</div>
                <div className="rulesDialogRuleWrapper">
                    <Dot/>
                    <div className="rulesDialogCriminal"></div>
                    <div className="rulesDialogRule">Identifies the player who receives a red card for the round</div>
                </div>
                <div className="rulesDialogRuleWrapper">
                    <Dot/>
                    <img className="rulesDialogJudgeHammerIcon" src={judgeHammer} alt="judge"/>
                    <div className="rulesDialogRule">Identifies Judge for the round</div>
                </div>
                <div className="rulesDialogRuleWrapper">
                    <Dot/>
                    <div className="rulesDialogRule">A player gets assigned a red card, and players submit a black card as karma</div>
                </div>
                <div className="rulesDialogRuleWrapper">
                    <Dot/>
                    <div className="rulesDialogRule">Judge chooses winning karma, player who submitted it gets 1pt*</div>
                </div>
                <div className="rulesDialogRuleWrapper">
                    <Dot/>
                    <div className="rulesDialogRule">First player to 5pts wins!</div>
                </div>
            </div>
        </div>
    );
};

export default RulesDialog;